/**
 * Class description
 *
 * Created: 2017-10-09
 * @author jonas
 */
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {TeslaReelView} from "./TeslaReelView";
import {TeslaStateReelSymbol} from "./TeslaStateReelSymbol";
import {IReelStartSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Tesla} from "../Tesla";

export class TeslaReelController extends SpinReelController {

    constructor(reelId:number) {
        super(reelId);
    }

    public moveSymbolToBottomLayer(symbol:StateReelSymbol):void {
        (<TeslaReelView>this._reelView).addChildToBottom(symbol);
    }

    public moveSymbolToTopLayer(symbol:StateReelSymbol):void {
        (<TeslaReelView>this._reelView).addChildToTop(symbol);
    }

    protected addNewSymbol(symName:string, state?:ISymbolStateConfig):TeslaStateReelSymbol {
        const symbol:TeslaStateReelSymbol = <TeslaStateReelSymbol>super.addNewSymbol(symName, state);
        return symbol;
    }

    protected startSpinAnimation(data: IReelStartSpinData, previousDelay: number): number {
        Tesla.betLineWinView.clearView();
        return super.startSpinAnimation(data, previousDelay);
    }
}